import { axiosSwagger } from "@/axios";

export const state = {
    loading: false,
    data: [],
    total: 0,
}


export const getters = {
}


export const mutations = {
    // ACCESS LEVEL
    loading: (state, loading) => {
        state.loading = loading;
    },
    setData: (state, data) => {
        state.data = data;
    },
    setTotal: (state, total) => {
        state.total = total;
    },
}


export const actions = {
  async readFileContent({ commit }, payload) {
    const id = typeof payload === 'object' ? payload.id : payload;
    const onProgress = typeof payload === 'object' ? payload.onProgress : null;
    
    commit("loading", true);
    
    try {
      const response = await axiosSwagger.get(
        `/api/FileManagerFile/ReadFile/Stream/${id}`,
        {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            if (onProgress && progressEvent.total) {
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              onProgress({
                loaded: progressEvent.loaded,
                total: progressEvent.total,
                progress: percentCompleted
              });
            }
          }
        }
      );
      
      commit("loading", false);
      return response.data;
    } catch (error) {
      commit("loading", false);
      throw error;
    }
  }
}